import { isString } from '@utils';

export const transformNumberFormat = (value: unknown) =>
  isString(value) ? value.replace(',', '.') : value;
